import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  getAnamnezHemsListe, getAnamnezHemsDetay,
  yeniAnamnezHems, guncelleAnamnezHems, silAnamnezHems
} from '../services/api';

export default function AnamnezHems() {
  const { kayitNo } = useParams();
  const navigate = useNavigate();
  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
  const yetk50 = kullanici.yetk50 === 1;

  const [liste, setListe] = useState([]);
  const [seciliId, setSeciliId] = useState(null);
  const [detay, setDetay] = useState(null);
  const [form, setForm] = useState({ ack1: '', ack2: '', ack3: '', ack4: '' });
  const [mod, setMod] = useState(null); // 'yeni' | 'duzenle' | null
  const [yukleniyor, setYukleniyor] = useState(true);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [mesaj, setMesaj] = useState('');

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hastaAdi = searchParams.get('ad') || '';
  const masterProtNo = searchParams.get('mprotno');

  useEffect(() => {
    yukle();
  }, [kayitNo]);

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const res = await getAnamnezHemsListe(kayitNo, masterProtNo);
      setListe(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setYukleniyor(false);
    }
  };

  const kayitSec = async (id) => {
    setSeciliId(id);
    setMod(null);
    try {
      const res = await getAnamnezHemsDetay(id);
      setDetay(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const yeniKayitAc = () => {
    setSeciliId(null);
    setDetay(null);
    setForm({ ack1: '', ack2: '', ack3: '', ack4: '' });
    setMod('yeni');
  };

  const duzenleAc = () => {
    if (!detay) return;
    setForm({
      ack1: detay.ack1 || '',
      ack2: detay.ack2 || '',
      ack3: detay.ack3 || '',
      ack4: detay.ack4 || '',
    });
    setMod('duzenle');
  };

  const kaydet = async () => {
    setKaydediliyor(true);
    try {
      if (mod === 'yeni') {
        await yeniAnamnezHems({
          kayitNo: kayitNo.toString(),
          adSoy: hastaAdi,
          ack1: form.ack1,
          ack2: form.ack2,
          ack3: form.ack3,
          ack4: form.ack4,
          who: kullanici.adSoyad,
          whoNo: kullanici.noo,
          masterProtNo: 0
        });
        setMesaj('Kaydedildi ✓');
      } else if (mod === 'duzenle') {
        await guncelleAnamnezHems(detay.id, {
          ...detay,
          ack1: form.ack1,
          ack2: form.ack2,
          ack3: form.ack3,
          ack4: form.ack4,
        });
        setMesaj('Güncellendi ✓');
      }
      setTimeout(() => setMesaj(''), 2000);
      setMod(null);
      await yukle();
    } catch (err) {
      setMesaj('Hata oluştu!');
    } finally {
      setKaydediliyor(false);
    }
  };

  const sil = async (id) => {
    if (!window.confirm('Bu kayıt silinecek. Emin misiniz?')) return;
    try {
      await silAnamnezHems(id);
      setDetay(null);
      setSeciliId(null);
      await yukle();
    } catch (err) {
      alert('Silme hatası!');
    }
  };

  const tarihFormat = (tar) => {
    if (!tar) return '';
    return new Date(tar).toLocaleDateString('tr-TR');
  };

  const alanlar = [
    { key: 'ack1', etiket: 'HEMŞİRE ANAMNEZİ', renk: '#E1F5EE' },
    { key: 'ack2', etiket: 'HEMŞİRE MUAYENE BULGULARI', renk: '#FAEEDA' },
    { key: 'ack3', etiket: 'HEMŞİRE ÖN TANILARI', renk: '#FFF9C4' },
    { key: 'ack4', etiket: 'HEMŞİRE MÜDAHALELERİ', renk: '#FCE4EC' },
  ];

  return (
    <div>
      <button className="btn btn-secondary" style={{ marginBottom: 16, fontSize: 12 }} onClick={() => navigate(-1)}>← Geri</button>

      {/* Başlık */}
      <div style={{ background: 'var(--med-dark)', borderRadius: 'var(--radius)', padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ color: '#fff', fontWeight: 600 }}>HEMŞİRE ANAMNEZİ</div>
          <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>Hasta #{kayitNo} {hastaAdi && `· ${hastaAdi}`}</div>
        </div>
        {yetk50 && (
          <button className="btn" style={{ background: 'var(--med-accent)', color: '#fff', fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}
            onClick={yeniKayitAc}>
            ➕ Kayıt Ekle
          </button>
        )}
      </div>

      {/* YENİ KAYIT FORMU */}
      {mod === 'yeni' && (
        <div className="card" style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--med-primary)', marginBottom: 14, paddingBottom: 8, borderBottom: '1px solid var(--border)' }}>
            Yeni Hemşire Anamnezi
          </div>
          {alanlar.map(a => (
            <div key={a.key} style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 5 }}>{a.etiket}</div>
              <textarea rows={3} style={{ width: '100%', padding: '8px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, resize: 'vertical', background: a.renk, fontFamily: 'inherit' }}
                value={form[a.key]}
                onChange={e => setForm(prev => ({ ...prev, [a.key]: e.target.value }))}
              />
            </div>
          ))}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn btn-secondary" onClick={() => setMod(null)}>İptal</button>
            <button className="btn btn-primary" onClick={kaydet} disabled={kaydediliyor}>
              {kaydediliyor ? 'Kaydediliyor...' : '💾 Kaydet'}
            </button>
          </div>
          {mesaj && <div style={{ marginTop: 8, fontSize: 12, color: '#1D9E75', textAlign: 'right' }}>{mesaj}</div>}
        </div>
      )}

      {/* LİSTE */}
      <div className="card" style={{ padding: 0, overflow: 'hidden', marginBottom: 16 }}>
        {yukleniyor ? (
          <div className="loading">Yükleniyor...</div>
        ) : liste.length === 0 ? (
          <div className="empty">Henüz hemşire anamnezi kaydı yok</div>
        ) : liste.map(k => (
          <div key={k.id}
            style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', cursor: 'pointer', background: seciliId === k.id ? 'var(--med-light)' : 'transparent', transition: 'background 0.1s', borderLeft: seciliId === k.id ? '3px solid var(--med-accent)' : '3px solid transparent' }}
            onClick={() => kayitSec(k.id)}
          >
            <div style={{ fontWeight: 500, fontSize: 13, color: 'var(--med-primary)' }}>
              {tarihFormat(k.tar)} - {k.saat} · {k.who}
            </div>
          </div>
        ))}
      </div>

      {/* DETAY */}
      {detay && mod !== 'duzenle' && (
        <div className="card">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, paddingBottom: 8, borderBottom: '1px solid var(--border)' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--med-primary)' }}>Hemşire Anamnez Kayıtları</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{tarihFormat(detay.tar)} {detay.saat} · {detay.who}</div>
            </div>
            {yetk50 && (
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-secondary" style={{ fontSize: 12 }} onClick={duzenleAc}>✏️ Düzenle</button>
                <button className="btn" style={{ fontSize: 12, background: '#FCEBEB', color: '#A32D2D', border: '1px solid #F7C1C1' }} onClick={() => sil(detay.id)}>🗑️ Sil</button>
              </div>
            )}
          </div>
          {alanlar.map(a => detay[a.key] && (
            <div key={a.key} style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 5 }}>{a.etiket}</div>
              <div style={{ padding: '10px 14px', background: a.renk, borderRadius: 8, fontSize: 13, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
                {detay[a.key]}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* DÜZENLE FORMU */}
      {mod === 'duzenle' && detay && (
        <div className="card">
          <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--med-primary)', marginBottom: 14, paddingBottom: 8, borderBottom: '1px solid var(--border)' }}>
            Kayıt Düzenle
          </div>
          {alanlar.map(a => (
            <div key={a.key} style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 5 }}>{a.etiket}</div>
              <textarea rows={3} style={{ width: '100%', padding: '8px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, resize: 'vertical', background: a.renk, fontFamily: 'inherit' }}
                value={form[a.key]}
                onChange={e => setForm(prev => ({ ...prev, [a.key]: e.target.value }))}
              />
            </div>
          ))}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn btn-secondary" onClick={() => setMod(null)}>İptal</button>
            <button className="btn btn-primary" onClick={kaydet} disabled={kaydediliyor}>
              {kaydediliyor ? 'Kaydediliyor...' : '💾 Güncelle'}
            </button>
          </div>
          {mesaj && <div style={{ marginTop: 8, fontSize: 12, color: '#1D9E75', textAlign: 'right' }}>{mesaj}</div>}
        </div>
      )}
    </div>
  );
}
